import React, { Component,Suspense } from 'react';
//import classNames from 'classnames';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Message} from 'primereact/message';
import axios from './axios-url';
import Tooltip from './shared/UI/Tooltip/Tooltip';

// const OnCamera = React.lazy(()=> import('./components/AppWithImagePreview/AppWithImagePreview'))

export class AppProfile extends Component {

    constructor() {
        super();
        this.state = {
            expanded: false,
            file:null,
            message:false,
            url:false
        };
        //this.onClick = this.onClick.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    // onClick(event) {
    //     this.setState({expanded: !this.state.expanded});
    //     event.preventDefault();
    // }

    handleImageChange(e) {
        e.preventDefault();
        let file = e.target.files[0];
        let readerShow = new FileReader();
        readerShow.readAsDataURL(file);
     
        readerShow.onloadend = () => {    
          this.setState({ file: readerShow.result,message:true });
        };


        
        const frmData = new FormData();
        frmData.append('file', file,  file.name );
        
        return axios.post('/master/api/upload?FolderName=ProfileImage', frmData );
         




        //this.hideMessage();
    }

    componentDidMount(){
        this.setState({ message:false });

        let authenticated = localStorage.getItem('token') ? true : false

        if(authenticated){// rendering profile picture
            const clearTimer = () => clearInterval(interval);
            const interval = setInterval(() => {
                if (this.props.userDetail) {
                    clearTimer();
                    let extension = 'jpg';
                    let fileName = `${this.props.userDetail.userid1}.jpg`;
                    let folderName = 'ProfileImage';

                    axios({
                        url: `/master/api/Download?filename=${fileName}&&FolderName=${folderName}&&ext=${extension}`,
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        let profilePictureAvailable = response.data.type == 'application/octet-stream' ? true : false
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        if(profilePictureAvailable){
                            this.setState({url});
                        }                        
                        this.setState({loading: false})
                    }).catch((err) => {
                        this.setState({loading: false})
                    })                
                }
            }, 300);
        }

        

    }

    hideMessage = ()=>{

        setTimeout(() => {
            this.setState({ message:false });
        }, 3000);

    }
   

    handleTakePhotoAnimationDone = (dataUri) => {
        this.setState({ file: dataUri});
      }

    render() {

        const logo = require('./assets/images/profile.jpg');
        //assets/layout/images/profile.png

        let photoVisible = false;
        if(this.props.viewPhoto){
            photoVisible = true;
        }


        let uploadPhotoVisible = false;
        if(this.props.uploadPhoto){
            uploadPhotoVisible = true;
        }

        let takePhotoVisible = false;
        let startCamera = this.state.file;
        if(this.props.takePhoto){
            takePhotoVisible = true;
            startCamera= '';
        }

        let name ='';
        let userId ='';
        if(this.props.userDetail!==null){
            name =  this.props.userDetail.lastName +' '+ this.props.userDetail.firstName;
            userId = this.props.userDetail.userid1
        }
        return  (
            <div className="profile">

            <Dialog header="Take Photo" visible={takePhotoVisible} style={{width: '60vw',zIndex:'1003'}} onHide={this.props.closeTakePhoto}  modal={false}  >
               { (takePhotoVisible) && 
                <Suspense fallback={<div>Loading...</div>}>
                    {/* <OnCamera handleTakePhotoAnimationDone={this.handleTakePhotoAnimationDone} dataUri={startCamera}/> */}
                </Suspense>
               }
               <div className="p-col-12" style={{textAlign:'right'}}>
                    <Button label="Close" className="p-button-secondary" onClick={this.props.closeTakePhoto} />
                </div>
            </Dialog>


            <Dialog header="Profile Photo" visible={photoVisible} style={{width: '37vw'}} onHide={this.props.closePhoto}  modal={false}  >
                { (this.state.url) ? <img src={this.state.url} alt="Avatar" style={{width:'100%'}}/> : <img src={logo}  style={{width:'100%'}} alt="Avatar" />}
            </Dialog>

            <Dialog header="Upload Photo" visible={uploadPhotoVisible} style={{width: '50vw'}} onHide={this.props.closeUploadPhoto} modal={false}  >
            <div className="p-grid" style={{textAlign:'center'}}>
                <div className="p-col-12" style={{marginTop:'2.5em'}}>
                <label className="photo"> Select Your Photo
                    <input type="file" className="custom-file-upload" name="file" onChange={this.handleImageChange}/>
                </label> 

                <br/>
                {this.state.message && <Message severity="success" text="Image Saved" style={{marginTop:'1em'}}/>}
                </div>

                <div className="p-col-12" style={{textAlign:'right'}}>
                <Button label="Close" className="p-button-secondary" onClick={this.props.closeUploadPhoto} />
                </div>
            </div>
            </Dialog>
            
            
            <div className="layout-profile">
                <div className="container1">
                    { (this.state.url) ? <img src={this.state.url} alt="Avatar" className="image"/> : <img src={logo}  alt="Avatar" className="image"/>}
                    <div className="overlay">
                        <div href="#" className="icon" title="User Profile"  onClick={this.props.imageMenu} >
                            <i className="fa fa-user"></i>
                            <input type="file" name="file" onChange={this.handleImageChange}/>
                        </div>
                    </div>
                </div> 
                <Tooltip title="Profile">
                <button className="p-link layout-profile-link">
                    <span className="username">{`${name} - (${userId})`}</span>
                    {/* <i className="pi pi-fw pi-cog"/> */}
                </button>
                </Tooltip>
                {/* <ul className={classNames({'layout-profile-expanded': this.state.expanded})}>
                    <li><button className="p-link"><i className="pi pi-fw pi-user"/><span>Account</span></button></li>
                    <li><button className="p-link"><i className="pi pi-fw pi-inbox"/><span>Notifications</span><span className="menuitem-badge">2</span></button></li>
                    <li><Link to="/log-out"><button className="p-link"><i className="pi pi-fw pi-power-off"/><span>Logout</span></button></Link></li> 
                </ul> */}
            </div>
            </div>    
        );
    }
}